import PropTypes from 'prop-types'
import React from 'react'
import {FormattedMessage} from 'react-intl'
import Checkbox from '../checkbox'
import Link from '../link'

const MarketingOptIn = ({testid, value, onChange, viewExtendedDescription}) => {
    onChange = onChange || ((newValue) => (value = newValue))

    return (
        <Checkbox
            size="sm"
            name="marketingOptIn"
            isChecked={value}
            data-testid={testid}
            onChange={(e) => {
                onChange(e.target.checked)
            }}
        >
            {!viewExtendedDescription && (
                <FormattedMessage
                    defaultMessage="Yes, I would like personalized emails about exclusive content, product recommendations and promotional updates from Stokke Group (Stokke AS and its subsidiaries) based on my profile data, purchase history and activities in Stokke digital channels. Unsubscribe link in every newsletter and in MyAccount. What personal data we process, why and how: {privacy}."
                    id="forms.marketing"
                    values={{
                        privacy: (
                            <Link
                                href="/customer-service/legal/privacy-policy.html"
                                isExternal
                                size="sm"
                            >
                                <FormattedMessage
                                    defaultMessage="Privacy Policy"
                                    id="footer.link.privacy_policy"
                                />
                            </Link>
                        )
                    }}
                />
            )}
            {viewExtendedDescription && (
                <FormattedMessage
                    defaultMessage="Yes, I would like personalized emails about exclusive content, product recommendations and promotional updates from Stokke Group (Stokke AS and its subsidiaries) based on my profile data, purchase history and activities in Stokke digital channels. Unsubscribe link in every newsletter and in MyAccount. What personal data we process, why and how: {privacy}."
                    id="forms.marketing2"
                    values={{
                        privacy: (
                            <Link
                                href="/customer-service/legal/privacy-policy.html"
                                isExternal
                                fontSize="inherit"
                            >
                                <FormattedMessage
                                    defaultMessage="Privacy Policy"
                                    id="footer.link.privacy_policy"
                                />
                            </Link>
                        )
                    }}
                />
            )}
        </Checkbox>
    )
}

MarketingOptIn.propTypes = {
    testid: PropTypes.string,
    value: PropTypes.bool,
    viewExtendedDescription: PropTypes.bool,
    onChange: PropTypes.func
}

export default MarketingOptIn
